<template>
    <div :class="{['checkbox-component'] : true, line : isLine,disable:isDisable}">
        <label :for="prefixId+id">
        </label>
        <input type="checkbox" :id="prefixId+id" :name="id" hidden="hidden" @change="handleCheckboxChange" :checked="isChecked" :disabled="isDisable">
        <div class="content-checkbox">

        </div>
    </div>
</template>

<script>
export default {
    name: 'checkbox',

    props: {
        id: String,
        prefixId: {
            default: 'false',
            type: String,
        },
        isLine: {
            default: false,
            type: Boolean,
        },
        isChecked: {
            default: false,
            type: Boolean,
        },
        isDisable: {
            default: false,
            type: Boolean,
        },

        add: Function,
        remove: Function
    },

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    computed: {
       
    },

    methods: {
        handleCheckboxChange(event) {
            if(event.target.checked) {
                this.add(this.id)
            }else{
                this.remove(this.id)
            }
        },

     
        
    }, 



    
};
</script>